const { getElement } = window.BAO.Utils

class HeaderSearchInput extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.shouldCycle || !this.speed) return

    this.stepInterval = 110

    this.ideaIndex = 0
    this.letterIndex = 0

    this.currentStep = 0
    this.totalSteps = Math.round(this.speed / this.stepInterval)

    this.updateIdea()
    this.interval = this.setupIdeas()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    clearInterval(this.interval)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  setupIdeas () {
    return setInterval(() => {
      this.updateIdea()
    }, this.stepInterval)
  }

  updateIdea () {
    if (this.ideaIndex + 1 > this.ideas.length) {
      this.ideaIndex = 0
    }

    const idea = this.ideas[this.ideaIndex]

    const currentString =
      this.currentStep <= 4
        ? this.string
        : `${this.string} ${idea.slice(0, this.letterIndex)}`

    this.els.input.element.setAttribute('placeholder', currentString)

    if (this.letterIndex <= idea.length && this.currentStep > 4) {
      this.letterIndex += 1
    }

    this.currentStep += 1

    if (this.currentStep >= this.totalSteps) {
      this.ideaIndex += 1
      this.currentStep = 0
      this.letterIndex = 0
    }
  }

  handleClick () {
    if (window.drawers?.activeDrawerKey === 'search') return
    this.drawers = getElement('site-drawers')
    this.drawers.open('search')
  }

  get ideas () {
    return this.dataset.ideas.split(',').map((idea) => idea.trim())
  }

  get speed () {
    return Number(this.dataset.speed) * 1000
  }

  get string () {
    return this.dataset.string
  }

  get shouldCycle () {
    return this.dataset.cyclePlaceholder !== 'false'
  }
}

if (!customElements.get('header-search-input')) {
  customElements.define('header-search-input', HeaderSearchInput)
}
